import Vue from 'vue'
Vue.use(Router)
import Router from 'vue-router'
import login from './components/login.vue'
import codeLogin from './components/codeLogin.vue'
import register from './components/register.vue'
import user from './components/user.vue'
import index from './components/index.vue'
import goodsDetail from './components/goodsDetail.vue'
import orderPage from './components/orderPage.vue'
import addressPage from './components/addresspage.vue'
import editAddress from './components/editAddressPage.vue'
import searchPage from './components/searchPage.vue'
import activity from './components/activity.vue'
import userInfo from './components/userInfo.vue'

// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error=> error)
// }
export default new Router({
  // mode:'history',
  routes: [
    {
      path:'/',
      name:'',
      component: index
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/codeLogin',
      name: 'codeLogin',
      component: codeLogin
    },
    {
      path:'/register',
      name:'register',
      component:register
    },
    {
      path:'/user',
      name:'user',
      component:user
    },
    {
      path:'/index',
      name:'index',
      component:index
    },
    {
      path:'/goodsDetail/:id',
      name:'goodsDetail',
      component:goodsDetail
    },
    {
      path:'/orderPage',
      name:'orderPage',
      component:orderPage
    },
    {
      path:'/addressPage',
      name:'addressPage',
      component:addressPage
    },
    {
      path:'/editAddress',
      name:'editAddress',
      component:editAddress
    },
    {
      path:'/searchPage',
      name:'searchPage',
      component:searchPage
    },
    {
      path:'/activity',
      name:'activity',
      component:activity
    },
    {
      path:'/userInfo',
      name:'userInfo',
      component:userInfo
    }
  ]
})

